import { CaretLeft } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import type { Lead } from "common/types";

import AddLeadNote from "./AddLeadNote";
import AddNoteButton from "./AddNoteButton";
import LeadNotesList from "./LeadNotesList";

interface LeadNotesProps {
  onBack: () => void;
  lead: Lead;
}

export default function LeadNotes({ lead, onBack }: LeadNotesProps) {
  const [isAddingNote, setIsAddingNote] = useState(true);

  return (
    <>
      <div className="flex p-4 gap-x-1.5 items-center border-b border-b-black-200">
        <Button
          variant="ghost-black"
          size="xs"
          intent="iconOnly"
          onClick={onBack}
        >
          <CaretLeft />
        </Button>
        <span className="text-md-bold">{lead.full_name}'s notes</span>
      </div>
      <div className="flex flex-col p-4 gap-y-2.5">
        {isAddingNote ? (
          <AddLeadNote
            profileId={lead.id}
            onDiscard={() => setIsAddingNote(false)}
          />
        ) : (
          <AddNoteButton onClick={() => setIsAddingNote(true)} />
        )}
        <LeadNotesList notes={lead.notes} profileId={lead.id} />
      </div>
    </>
  );
}
